
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"14","viewBox":"0 0 12 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 13.667c.874 0 1.605-.556 1.879-1.334H4.12A1.987 1.987 0 006 13.667zm4.667-4.943V5.667a4.67 4.67 0 00-3.43-4.495A1.327 1.327 0 006 .333c-.564 0-1.041.347-1.237.839a4.671 4.671 0 00-3.43 4.495v3.057L.195 9.862a.664.664 0 00-.195.471V11c0 .369.298.667.667.667h10.666A.666.666 0 0012 11v-.667a.664.664 0 00-.195-.471l-1.138-1.138z","fill":"#7E8186"}})])
          )
        }
      }
    